export const capitalizeString = (name: string) => {
  // todo: MUI already has this kind of function called "capitalize" use that everywhere
  return name.charAt(0).toUpperCase() + name.slice(1);
};
